import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
class NatureOfFunctionsFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default NatureOfFunctionsFormPresenter;
